import { useEffect, useState } from "react";
import { api } from "@/api";
import { toast } from "sonner";
import { Layers } from "lucide-react";
import { IncidentDrawEditor } from "@/components/IncidentMaps";

// Meldkamer-wide, incident-independent map layer. Draw once; shown as an overlay on all maps.
export function SharedLayerEditor({ canWrite, onSaved }) {
  const [drawings, setDrawings] = useState(null);
  const [enabled, setEnabled] = useState(true);
  const [center, setCenter] = useState(null);
  const [saving, setSaving] = useState(false);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    Promise.all([
      api.get("/map-layer").catch(() => ({ data: { drawings: {}, enabled: true } })),
      api.get("/buildings").catch(() => ({ data: [] })),
    ]).then(([m, b]) => {
      setDrawings(m.data.drawings && m.data.drawings.features ? m.data.drawings : { type: "FeatureCollection", features: [] });
      setEnabled(m.data.enabled !== false);
      const bb = (b.data || []).find((x) => x.lat != null);
      setCenter(bb ? { lat: bb.lat, lng: bb.lng } : { lat: 52.11, lng: 5.18 });
      setReady(true);
    });
  }, []);

  const save = async (gj) => {
    setSaving(true);
    try { await api.put("/map-layer", { drawings: gj, enabled }); setDrawings(gj); if (onSaved) onSaved(gj); toast.success("Gedeelde tekenlaag opgeslagen"); }
    catch (e) { toast.error("Opslaan mislukt"); }
    finally { setSaving(false); }
  };
  const toggleEnabled = async (v) => {
    setEnabled(v);
    try { await api.put("/map-layer", { drawings: drawings || { type: "FeatureCollection", features: [] }, enabled: v }); toast.success(v ? "Tekenlaag zichtbaar" : "Tekenlaag verborgen"); }
    catch (e) { toast.error("Opslaan mislukt"); }
  };

  if (!ready) return null;
  return (
    <div className="mt-4 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm" data-testid="shared-layer-editor">
      <div className="mb-1 flex items-center gap-2 text-sm font-bold text-slate-900"><Layers style={{ width: 16, height: 16 }} className="text-teal-600" /> Gedeelde tekenlaag</div>
      <p className="mb-3 text-xs text-slate-500">Teken hier een kaartlaag die los van incidenten altijd zichtbaar is op alle kaarten (o.a. de voertuig-app). Voeg labels toe door op een vorm te klikken.</p>
      <label className="mb-3 flex cursor-pointer items-center gap-2 rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 text-sm">
        <input type="checkbox" data-testid="shared-layer-enabled" disabled={!canWrite} checked={enabled} onChange={(e) => toggleEnabled(e.target.checked)} className="h-4 w-4 accent-teal-600" />
        <span className="font-semibold text-slate-800">Tekenlaag tonen op alle kaarten</span>
      </label>
      {canWrite ? (
        <IncidentDrawEditor lat={center.lat} lng={center.lng} label="Gedeelde laag" initial={drawings} onSave={save} onCancel={() => {}} saving={saving} />
      ) : (
        <div className="text-xs text-slate-400">Alleen-lezen.</div>
      )}
    </div>
  );
}
